import { useRef } from "react";
import ArtLayer from "../art/ArtLayer";
import { Bougainvillea, RoseCorner } from "../art/Flora";
import { HeartDivider } from "../art/Motifs";
import Reveal from "../Reveal";
import { useScrollScene } from "../hooks";

/*
 * Flora accents, all drawn from the opening card so every page belongs to the
 * same world: "spray-right" / "spray-left" hangs bougainvillea from a top corner,
 * "roses" sets a bouquet in each bottom corner.
 */
const Flora = ({ kind, seed }) => {
  if (kind === "roses") {
    return (
      <div className="rm-section__flora" aria-hidden="true">
        <div className="rm-section__roses rm-section__roses--left">
          <ArtLayer slot="rosesLeft">
            <RoseCorner seed={seed} />
          </ArtLayer>
        </div>
        <div className="rm-section__roses rm-section__roses--right">
          <ArtLayer slot="rosesRight">
            <RoseCorner mirror seed={seed + 7} />
          </ArtLayer>
        </div>
      </div>
    );
  }
  if (kind === "spray-right" || kind === "spray-left") {
    return (
      <div className="rm-section__flora" aria-hidden="true">
        <div className={`rm-section__spray rm-section__spray--${kind === "spray-left" ? "left" : "right"}`}>
          <ArtLayer slot="bougainvillea">
            <Bougainvillea seed={seed} density={0.55} />
          </ArtLayer>
        </div>
      </div>
    );
  }
  return null;
};

/**
 * One page of the invitation. Every section shares the same header: a tracked
 * kicker, a title (or an italic lead), and the card's heart divider.
 */
const Section = ({ id, className = "", label, kicker, title, lead, flora = "none", seed = 3, children }) => {
  const ref = useRef(null);
  useScrollScene(ref, { mode: "pass", vars: (p, reduced) => ({ "--p": reduced ? 0.5 : p }) });

  return (
    <section ref={ref} id={id} className={`rm-section rm-section--${flora} ${className}`} aria-label={label}>
      <Flora kind={flora} seed={seed} />
      <div className="rm-section__inner">
        <Reveal className="rm-section__head">
          {kicker && <p className="rm-kicker">{kicker}</p>}
          {title && <h2 className="rm-title">{title}</h2>}
          {lead && <p className="rm-lead">{lead}</p>}
          <HeartDivider />
        </Reveal>
        {children}
      </div>
    </section>
  );
};

export default Section;
